<div *ngIf="formGroup"
  class="yc-layout yc-layout-login flex-column justify-content-between">
  <div></div>
  <yc-form *ngIf="!bbidTiedToAnotherAccount"
    class="w-75"
    [formGroup]="formGroup"
    [formSubmit]="handleSubmit">
    <!-- Header -->
    <yc-panel
      [type]="PanelTypes.FormSectionHeader"
      [isFirst]="true"
      [title]="'common:hdrVerifyYourAccount' | ycI18n: 'VERIFY YOUR ACCOUNT'"
      [description]="'login:textSecurityCodeWasSent' | ycI18n: 'A security code has been sent to the email entered on the previous step. Please do not close this page. Remember to check your Spam folder if you don\'t see the email in the next few minutes. '">
    </yc-panel>

    <!-- Security Code -->
    <yc-input
      name="code"
      [label]="'common:lblPleaseEnterTheCodeBelow' | ycI18n : 'Please enter the code below'"
      [helpTextClass]="'text-danger'"
      [help]="codeInvalid ? codeInvalidText : ''">
    </yc-input>

    <!-- Sign In -->
    <div class="d-flex justify-content-end mobile-mb-100 mt-3">
      <yc-submit>
        <yc-i18n
          key="AUTH:textSignIn"
          defaultValue="Sign in">
        </yc-i18n>
      </yc-submit>
    </div>
  </yc-form>

  <!-- BBID tied to another account -->
  <gc-bbid-already-exists-block *ngIf="bbidTiedToAnotherAccount"
    [bbidEmail]="bbidEmail"
    [failReason]="failReason"
    [gcEmail]="username"
    [initialRoute]="initialRoute">
  </gc-bbid-already-exists-block>

  <div class="login-actions justify-content-between">
    <!-- Back to Signin -->
    <div *ngIf="!bbidTiedToAnotherAccount" 
      class="ms-3">
      <yc-button
        [langKey]="'common:btnBackToSignin'"
        [defaultText]="'Back to sign in'"
        [link]="true"
        [linkPath]="['../']">
      </yc-button>
    </div>

    <!-- Resend Code -->
    <div *ngIf="!bbidTiedToAnotherAccount"
      class="me-3">
      <yc-button
        [link]="true"
        [langKey]="'common:textResendSecurityCode'"
        [defaultText]="'Resend security code'"
        (onClick)="resendSecurityCode()">
      </yc-button>
    </div>

  </div>

</div>